// src/TerminiPage.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Kanit:wght@400;600;700;800&family=Inter:wght@300;400;500&display=swap');
  .jkl-terms-root{min-height:100vh;background:#0a0a0f;color:#f0ece4;font-family:'Inter',sans-serif;padding:60px 24px;}
  .jkl-terms-inner{max-width:720px;margin:0 auto;}
  .jkl-terms-header{margin-bottom:48px;padding-bottom:24px;border-bottom:1px solid rgba(255,255,255,0.07);}
  .jkl-terms-logo{font-family:'Kanit',sans-serif;font-size:18px;font-weight:900;letter-spacing:0.2em;color:#f0ece4;margin-bottom:20px;}
  .jkl-terms-title{font-family:'Kanit',sans-serif;font-size:32px;font-weight:800;margin-bottom:8px;}
  .jkl-terms-date{font-size:12px;color:#4a4a5a;}
  .jkl-terms-section{margin-bottom:36px;}
  .jkl-terms-section h2{font-family:'Kanit',sans-serif;font-size:16px;font-weight:700;letter-spacing:0.05em;color:#d4a550;text-transform:uppercase;margin-bottom:12px;}
  .jkl-terms-section p,.jkl-terms-section li{font-size:14px;color:#8a8a9a;line-height:1.75;margin-bottom:10px;}
  .jkl-terms-section ul{padding-left:20px;margin-bottom:10px;}
  .jkl-terms-section strong{color:#f0ece4;font-weight:500;}
  .jkl-terms-back{display:inline-flex;align-items:center;gap:8px;padding:10px 20px;border-radius:8px;border:1px solid rgba(255,255,255,0.1);background:transparent;color:#8a8a9a;font-family:'Inter',sans-serif;font-size:13px;cursor:pointer;transition:all 0.15s;margin-top:32px;}
  .jkl-terms-back:hover{border-color:rgba(212,165,80,0.4);color:#d4a550;}
`;

const SECTION_KEYS = ['s1','s2','s3','s4','s5','s6','s7','s8','s9','s10','contacts'];

export default function TerminiPage({ onBack }) {
  const { t } = useTranslation();
  return (
    <div className="jkl-terms-root">
      <style>{STYLES}</style>
      <div className="jkl-terms-inner">
        {onBack && (
          <button className="jkl-terms-back" onClick={onBack} style={{marginBottom:'32px'}}>{t('terms.back')}</button>
        )}
        <div className="jkl-terms-header">
          <div className="jkl-terms-logo">JKL</div>
          <div className="jkl-terms-title">{t('terms.title')}</div>
          <div className="jkl-terms-date">{t('terms.date')}</div>
        </div>
        {SECTION_KEYS.map(k => (
          <div key={k} className="jkl-terms-section">
            <h2>{t(`terms.${k}_h`)}</h2>
            <div dangerouslySetInnerHTML={{ __html: t(`terms.${k}`) }} />
          </div>
        ))}
        {onBack && (
          <button className="jkl-terms-back" onClick={onBack}>{t('terms.back')}</button>
        )}
      </div>
    </div>
  );
}
